import { useCustomFieldsSchemaQuery } from '~/lib/Queries';
import CustomTags from '~/components/customfields/CustomTags';
import CustomFields from '~/components/customfields/CustomFields';

const EditableCustomTags = ({ fields, type, id, className }) => {
    const { data: schemaData, isLoading } = useCustomFieldsSchemaQuery(type);
    const schema = schemaData || [];

    const editableKeys = [];
    const nonEditableKeys = [];

    /**
     * Grab any fields:
     * - that are tags AND dropdowns
     * - exclude those from the fields shown in the normal custom tags?
     */
    schema.forEach(item => {
        if (item.schema.is_tag && item.schema?.type === 'dropdown') {
            editableKeys.push(item.key);
        } else {
            nonEditableKeys.push(item.key);
        }
    });

    return (
        <div
            className={`w-52 ${className}`}
            onClick={ev => ev.stopPropagation()}
        >
            <CustomTags
                fields={fields}
                type={type}
                id={id}
                excludeFields={editableKeys}
            />
            <div className="-ml-3">
                <CustomFields
                    fields={fields}
                    type={type}
                    id={id}
                    excludeFields={nonEditableKeys}
                    hideTooltip={true}
                />
            </div>
        </div>
    );
};

export default EditableCustomTags;
